import { route } from "remix/fetch-router/routes";

export const routes = route({
  content: "/content",
  more: "/more",
});
